var map = {
	"./_template.jsx": 387,
	"./docs/AssetDonator.json": 1080,
	"./docs/AssetsManager.json": 1081,
	"./docs/AssetsManagerEmitter.json": 1082,
	"./docs/AssetsManagerMock.json": 1083,
	"./docs/BaseManager.json": 1084,
	"./docs/BlockLimitedCrowdsale.json": 1085,
	"./docs/BlockLimitedCrowdsaleFactory.json": 1086,
	"./docs/ChronoBankAsset.json": 1087,
	"./docs/ChronoBankAssetFactory.json": 1088,
	"./docs/ChronoBankAssetProxy.json": 1089,
	"./docs/ChronoBankAssetWithFee.json": 1090,
	"./docs/ChronoBankAssetWithFeeFactory.json": 1091,
	"./docs/ChronoBankAssetWithFeeProxy.json": 1092,
	"./docs/ChronoBankPlatform.json": 1093,
	"./docs/ChronoBankPlatformEmitter.json": 1094,
	"./docs/ChronoBankPlatformFactory.json": 1095,
	"./docs/ChronoBankPlatformTestable.json": 1096,
	"./docs/ChronoBankTokenExtensionFactory.json": 1097,
	"./docs/ChronoBankWalletFallbackSupporter.json": 1098,
	"./docs/Clock.json": 1099,
	"./docs/ContractsManager.json": 1100,
	"./docs/CrowdsaleManager.json": 1101,
	"./docs/CrowdsaleManagerEmitter.json": 1102,
	"./docs/CryptocomparePriceTicker.json": 1103,
	"./docs/Deposits.json": 1104,
	"./docs/DepositsDeprecated.json": 1105,
	"./docs/ERC20DepositStorage.json": 1106,
	"./docs/ERC20Manager.json": 1107,
	"./docs/ERC20ManagerEmitter.json": 1108,
	"./docs/Exchange.json": 1109,
	"./docs/ExchangeFactory.json": 1110,
	"./docs/ExchangeManager.json": 1111,
	"./docs/ExchangeManagerEmitter.json": 1112,
	"./docs/FakeCoin.json": 1113,
	"./docs/FakeCoin2.json": 1114,
	"./docs/FakeCoin3.json": 1115,
	"./docs/FakePriceTicker.json": 1116,
	"./docs/FakePriceTickerManager.json": 1117,
	"./docs/FeatureFeeManager.json": 1118,
	"./docs/KrakenPriceTicker.json": 1119,
	"./docs/LHT.json": 1120,
	"./docs/LOCManager.json": 1121,
	"./docs/LOCManagerEmitter.json": 1122,
	"./docs/LOCWallet.json": 1123,
	"./docs/Managed.json": 1124,
	"./docs/ManagerMock.json": 1125,
	"./docs/Migrations.json": 1126,
	"./docs/MultiEventsHistory.json": 1127,
	"./docs/MultiEventsHistoryAdapter.json": 1128,
	"./docs/Object.json": 1129,
	"./docs/Once.json": 1130,
	"./docs/Owned.json": 1131,
	"./docs/OwnedContract.json": 1132,
	"./docs/PendingManager.json": 1133,
	"./docs/PendingManagerEmitter.json": 1134,
	"./docs/PlatformTokenExtensionGatewayManager.json": 1135,
	"./docs/PlatformTokenExtensionGatewayManagerEmitter.json": 1136,
	"./docs/PlatformsManager.json": 1137,
	"./docs/PlatformsManagerDammyDeprecated.json": 1138,
	"./docs/PlatformsManagerEmitter.json": 1139,
	"./docs/PollBackend.json": 1140,
	"./docs/PollEmitter.json": 1141,
	"./docs/PollFactory.json": 1142,
	"./docs/PollRouter.json": 1143,
	"./docs/Rewards.json": 1144,
	"./docs/RewardsEmitter.json": 1145,
	"./docs/RewardsWallet.json": 1146,
	"./docs/Rooted.json": 1147,
	"./docs/SafeMath.json": 1148,
	"./docs/SetStorageInterface_v_1_1.json": 1149,
	"./docs/Storage.json": 1150,
	"./docs/StorageAdapter.json": 1151,
	"./docs/StorageInterface.json": 1152,
	"./docs/StorageManager.json": 1153,
	"./docs/StringsLib.json": 1154,
	"./docs/Stub.json": 1155,
	"./docs/TIME.json": 1156,
	"./docs/TimeAsset.json": 1157,
	"./docs/TimeAssetProxy.json": 1158,
	"./docs/TimeHolder.json": 1159,
	"./docs/TimeHolderDammyWallet.json": 1160,
	"./docs/TimeHolderDeprecated.json": 1161,
	"./docs/TimeHolderEmitter.json": 1162,
	"./docs/TimeHolderWallet.json": 1163,
	"./docs/TimeLimitedCrowdsale.json": 1164,
	"./docs/TimeLimitedCrowdsaleFactory.json": 1165,
	"./docs/TimePlatform.json": 1166,
	"./docs/TimePlatformEmitter.json": 1167,
	"./docs/TokenExtensionRouter.json": 1168,
	"./docs/TokenFactory.json": 1169,
	"./docs/UserManager.json": 1170,
	"./docs/UserManagerEmitter.json": 1171,
	"./docs/UserProxy.json": 1172,
	"./docs/VotingManager.json": 1173,
	"./docs/VotingManagerEmitter.json": 1174,
	"./docs/Wallet.json": 1175,
	"./docs/WalletEmitter.json": 1176,
	"./docs/WalletsFactory.json": 1177,
	"./docs/WalletsManager.json": 1178,
	"./docs/WalletsManagerEmitter.json": 1179,
	"./docs/_template.jsx": 1180,
	"./index.md": 1181
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|jsx|js|markdown|md|ipynb|html|json|yaml|toml)$
// module id = 1079
// module chunks = 0